/** The most tool names one session may seat. Every room seats every governed
 * door (23 September 2026: 176 names), so the bound sits well above the whole
 * governed toolkit; the World, the Desk and Pocket all read this one constant. */
export const SESSION_TOOL_NAMES_MAX = 1024;

/** Canonical field order survives Convex serialization. Absence is the legacy
 * empty receipt, never permission to read today's session choice. */
export function frozenSessionToolsValue(
  value:
    | {
        readonly revision: number;
        readonly toolNames: ReadonlyArray<string>;
      }
    | undefined,
) {
  return value === undefined
    ? undefined
    : { revision: value.revision, toolNames: [...value.toolNames] };
}

export function validFrozenSessionTools(
  value: unknown,
): value is { readonly revision: number; readonly toolNames: ReadonlyArray<string> } {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  const fields = value as Record<string, unknown>;
  if (
    Object.keys(fields).some((key) => !["revision", "toolNames"].includes(key)) ||
    !Number.isSafeInteger(fields.revision) ||
    Number(fields.revision) < 0 ||
    !Array.isArray(fields.toolNames) ||
    fields.toolNames.length > SESSION_TOOL_NAMES_MAX
  )
    return false;
  return fields.toolNames.every(
    (name, index, names) =>
      typeof name === "string" &&
      name.length > 0 &&
      name.length <= 256 &&
      name === name.trim() &&
      (index === 0 || names[index - 1] < name),
  );
}
